import { Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useState, useEffect } from 'react'
import Navigation from './components/Navigation'
import Hero from './components/Hero'
import Presenting from './components/Presenting'
import Features from './components/Features'
import Mission from './components/Mission'
import ClubOwner from './components/ClubOwner'
import Contact from './components/Contact'
import Footer from './components/Footer'

function App() {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    // Small delay to ensure all styles are loaded before showing content
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="min-h-screen bg-dark-900" style={{ margin: 0, padding: 0 }}>
      <Navigation />
      <main style={{ margin: 0, padding: 0 }}>
        <Routes>
          <Route path="/" element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: isLoaded ? 1 : 0 }}
              transition={{ duration: 0.3, delay: 0.1 }}
              style={{ margin: 0, padding: 0 }}
            >
          <Hero />
          <Presenting />
          <Features />
          <Mission />
          <ClubOwner />
          <div 
            className="contact-footer-wrapper relative overflow-hidden"
            style={{
              backgroundColor: '#000000',
              minHeight: 'calc(100vh + 200px)'
            }}
          >
            {/* Background images that span both Contact and Footer */}
            <div 
              className="absolute top-0 flex items-center"
              style={{
                left: 0,
                width: '50vw',
                height: '100%',
                opacity: 0.8,
                zIndex: 5,
                justifyContent: 'flex-start',
                padding: 0,
                margin: 0
              }}
            >
              <img 
                src="/Group512703.svg" 
                alt="Geometric lines" 
                className="object-contain"
                style={{ 
                  width: '100%',
                  height: '100%',
                  marginLeft: 0,
                  transform: 'translateX(-15%)',
                  objectFit: 'cover',
                  objectPosition: 'center bottom'
                }}
              />
            </div>
            
            <div 
              className="absolute top-0 right-0 flex items-center justify-end"
              style={{
                width: '50vw',
                height: '100%',
                opacity: 0.6,
                zIndex: 6
              }}
            >
              <img 
                src="/footer_bg.png" 
                alt="Poker cards" 
                className="object-cover"
                style={{ 
                  width: '100%', 
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center bottom'
                }}
              />
            </div>
            
            <Contact />
            <Footer />
          </div>
            </motion.div>
          } />
        </Routes>
      </main>
    </div>
  )
}

export default App
